module.exports = __webpack_public_path__ + "img/mode-battle.bfca49a2.svg";